import React from 'react';
import Select from 'react-select';
import { useTheme } from '@material-ui/core/styles';
import { Layout } from '../../configs/ui/constant';
import chroma from 'chroma-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const dot = (color = '#ccc') => ({
   alignItems: 'center',
   display: 'flex',

   ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 10,
      width: 10,
   },
});
export const MySelect = (props) => {
   const theme = useTheme();
   const {
      closeMenuOnSelect,
      onChange,
      isLoading,
      value,
      placeholder,
      isDisabled,
      defaultValue,
      name,
      title,
      options,
      alert,
      isMulti,
      onMenuOpen,
      colourStyles,
      menuShowInbody,
      defaultInputValue,
      inputValue,
      isClearable,
      menu,
   } = props;
   const customStyles = {
      input: (base) => ({
         ...base,
         fontFamily: `'DBHeavent', sans-serif `,
         '& input': {
            font: 'inherit',
         },
      }),
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         fontFamily: `'DBHeavent', sans-serif `,
         fontSize: '22px',
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      menu: (base) => ({
         ...base,
         top: menu == 'top' ? 'auto' : '100%',
         bottom: menu == 'top' ? '100%' : 'auto',
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
         fontSize: '22px',
         // borderRadius: "5px",
      }),
      menuList: (base) => ({
         ...base,
      }),
      singleValue: (base) => ({
         ...base,
      }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      dropdownIndicator: (base) => ({
         ...base,
      }),
      placeholder: (base) => ({
         ...base,
      }),
      container: (base) => ({
         ...base,
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };
   const mycolourStyles = {
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      // option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      //   const color = chroma(data.color);
      //   return {
      //     ...styles,
      //     backgroundColor: isDisabled
      //       ? null
      //       : isSelected
      //       ? data.color
      //       : isFocused
      //       ? color.alpha(0.1).css()
      //       : null,
      //     color: isDisabled
      //       ? "#ccc"
      //       : isSelected
      //       ? chroma.contrast(color, "white") > 2
      //         ? "white"
      //         : "black"
      //       : data.color,
      //     cursor: isDisabled ? "not-allowed" : "default",
      //
      //     ":active": {
      //       ...styles[":active"],
      //       backgroundColor:
      //         !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
      //     },
      //   };
      // },
      input: (styles) => ({ ...styles, ...dot() }),
      menu: (base) => ({
         ...base,
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
         // borderRadius: "5px",
      }),
      placeholder: (styles) => ({ ...styles, ...dot() }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };

   // Define custom rendering for options with FontAwesomeIcon
   const getOptionLabel = (e) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
         {e.icon && (
            <FontAwesomeIcon
               icon={e.icon} // Pass icon directly from options
               style={{ marginRight: 5, width: '16px' }}
            />
         )}
         {e.label}
      </div>
   );

   return (
      <React.Fragment>
         <Select
            name={name}
            id={title}
            options={options}
            onChange={onChange}
            value={value && value}
            styles={colourStyles ? mycolourStyles : customStyles}
            defaultValue={defaultValue && defaultValue}
            defaultInputValue={defaultInputValue && defaultInputValue}
            inputValue={inputValue && inputValue}
            placeholder={placeholder}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isMulti={!!isMulti}
            closeMenuOnSelect={!!closeMenuOnSelect}
            menuPortalTarget={
               menuShowInbody ? document.querySelector('body') : false
            }
            onMenuOpen={onMenuOpen}
            isClearable={isClearable === undefined ? true : isClearable}
            getOptionLabel={getOptionLabel} // ใช้ฟังก์ชันกำหนดรูปแบบ option
            menu={menu}
            // inputProps={{readOnly:true}}
         />
      </React.Fragment>
   );
};
